import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, Response } from '@angular/http';
import {AuthHttp} from 'angular2-jwt';
import { Observable }     from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import {tokenNotExpired} from 'angular2-jwt';

import {AppSettings} from '../app-settings';

import 'rxjs/add/operator/catch';
import 'rxjs/observable/throw';

@Injectable()
export class FeatureService {

  public token: string;

  headers = new Headers({'Accept': 'application/json'});
  options = new RequestOptions({headers: this.headers});

  constructor(private http: Http, private authHttp: AuthHttp) {
   var currentUser = JSON.parse(localStorage.getItem('currentUser'));
   this.token = currentUser && currentUser.token;
  }

  getFeatures(eventId): Observable<any> {
   return this.http.get(AppSettings.API_STARTPOINT+"/public/api/v1/feature/get",{
    params : {
     eventId:eventId
    }
   }).map(response => response.json().features);
  }

  getFeaturesWithOptions(eventId): Observable<any> {
   return this.http.get(AppSettings.API_STARTPOINT+"/public/api/v1/feature/get_with_options",{
    params : {
     eventId:eventId
    }
   }).map(response => response.json().features);
  }

  findFeature(featureId): Observable<any> {
   return this.authHttp.get(AppSettings.API_STARTPOINT+"/public/api/v1/feature/find",{
    params : {
     id:featureId
    }
   }).map(response => response.json().feature);
  }

  findFeatureWithOptions(featureId): Observable<any> {
   return this.authHttp.get(AppSettings.API_STARTPOINT+"/public/api/v1/feature/find_with_options",{
    params : {
     id:featureId
    }
   }).map(response => response.json().feature);
  }

  saveFeature(params): Observable<any> {
   return this.authHttp.post(AppSettings.API_STARTPOINT+"/public/api/v1/feature/save", params, this.options).map(response => response.json());
  }

  deleteFeature(params): Observable<any> {
   return this.authHttp.post(AppSettings.API_STARTPOINT+"/public/api/v1/feature/delete", params, this.options).map(response => response.json());
  }

  getFeatureOptions(params): Observable<any> {
   return this.authHttp.get(AppSettings.API_STARTPOINT+"/public/api/v1/feature/get_feature_options",{
    params : {
     featureId:params.featureId
    }
   }).map(response => response.json().featureOptions);
  }

  findFeatureOption(featureOptionId): Observable<any> {
   return this.authHttp.get(AppSettings.API_STARTPOINT+"/public/api/v1/feature/find_feature_option",{
    params : {
     id:featureOptionId
    }
   }).map(response => response.json().featureOption);
  }

  saveFeatureOption(params): Observable<any> {
   return this.authHttp.post(AppSettings.API_STARTPOINT+"/public/api/v1/feature/"+(params.id?'edit_feature_option':'add_feature_option'), params, this.options).map(response => response.json());
  }

  deleteFeatureOption(params): Observable<any> {
   return this.authHttp.post(AppSettings.API_STARTPOINT+"/public/api/v1/feature/delete_feature_option", params, this.options).map(response => response.json());
  }

  saveLodgingInformation(params): Observable<any> {
    return this.authHttp.post(AppSettings.API_STARTPOINT + "/public/api/v1/lodging_information/save", params, this.options).map(response => response.json());
  }
  
}



// WEBPACK FOOTER //
// /var/www/html/nissco_event_web/angular/src/app/common/feature.service.ts